// "+19085551234" | "9085551234" | "(908) 555-1234" -> "(908) 555-1234"
const usPhoneNumber = (phoneNumber: string): string => {
  const digits = phoneNumber.replace(/\D/g, "").replace(/^1(\d{10})$/, "$1");

  if (digits.length !== 10) return phoneNumber;

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export default usPhoneNumber;
